import React from 'react';
import Spinner from '@material-ui/core/CircularProgress';
import customQueryStyles from '../../views/CustomQuery/CustomQueryStyle';
import styled from 'styled-components';
export const StyledNoData = styled.div`
  display: flex;
  height: 300px;
  justify-content: space-around;
  align-items: center;
`;

const SpinnerComponent = () => {
  return /*#__PURE__*/React.createElement(Spinner, {
    animation: "border",
    role: "status",
    style: customQueryStyles.spinnerStyle
  });
};

export default SpinnerComponent;